const HTTPMEHOD = {
  GET: 'get',
  PUT: 'put',
  POST: 'post',
  HEAD: 'head',
  PATCH: 'patch',
  DELETE: 'delete',
  REQUEST: 'request',
  OPTIONS: 'options',
};

export default HTTPMEHOD;
